import { predictableMethods } from "./predictableMethods";
import { Polyfill } from "./polyfill";

export default class Predictable {
  constructor(options) {
    this.editorId = options.editorId;
    this.predictableContainerId = options.predictableContainerId;
    this.editor = options.editor;
    this.active = false;
    this.data = {
      // Data for suggested phrases can be obtained in numerous ways. E.g. a single static source can be used,
      // or a function can be passed to hydrate initial suggestions from a list before switching to a dynamic
      // data source.
      source: options.data,
      cache: false,
    };
    this.context = options.context;
    this.sensitivity = options.sensitivity || 3;
    this.predictableContainer = {
      view: predictableMethods.createResultsList({
        container:
          options.predictableContainer && options.predictableContainer.container
            ? options.predictableContainer.container
            : false,
        destination: options.editor,
        position: "afterend",
        element: "div",
      }),
    };
    this.suggestionText = {
      content:
        options.suggestionText && options.suggestionText.content
          ? options.suggestionText.content
          : false,
      element: "span",
    };
    this.onTabPress = options.onTabPress;
    this.suggestionsData = options.suggestionsData;
    this._initPredictable();
  }

  get promptData() {
    return this.data.source;
  }

  set promptData(newData) {
    this.data = {
      source: newData,
    };
    this._initPredictableOnRerender()

  }

  _initPredictableOnRerender(){
      this.suggestionsData = this.data.source;
      this.reRenderSuggestion();
      Polyfill.initElementClosestPolyfill();
  }

  _initPredictable() {
    this.suggestionsData = this.data.source;
    this.renderSuggestions();
    Polyfill.initElementClosestPolyfill();
  }

  lookupSuggestions = (currentText, suggestion) => {
    // Use `startsWith` method to ensure that only predictions exactly matching the currently typed word
    // are rendered. Otherwise, the prediction container's visual alignment will be thrown off.
    //let hardcodesuggestion = "As per section R303.6, Openings that terminate outdoors shall be protected with corrosion-resistant screens, louvers or grilles having an opening size of not less than 1/4 inch (6 mm) and a maximum opening size of 1/2 inch (13 mm)"
    let replacedString = suggestion.replace(/[^a-zA-Z0-9./ ]/g, "")

    /*Splitting the input text to get the last entered word*/
    let currentTextArray = currentText.split(" ");
    let filteredArray = currentTextArray.filter(entry => entry.trim() != "");
    let lastWord=filteredArray.pop();
   
    /*Splitting the suggestion array*/
    let truncatedArray = suggestion.split(" ")
    let replacedStringArray = replacedString.split(" ")
    /*Creating a case ignorant array for comparison*/
    let caseIgnorantArray = replacedStringArray.map(item=>item.toLowerCase())
    let currentTextIndex = caseIgnorantArray.indexOf(lastWord.toLowerCase().trim())
    let newSuggestion="";

    /* Search in the original array for the remaining suggestion*/
    if(currentTextIndex!==-1){
      let newSuggest = truncatedArray.slice(currentTextIndex+1)
      if(newSuggest.length > 1)
      newSuggestion = newSuggest.join(' ')
    }
    else{
      newSuggestion=""
    }
      return newSuggestion
  };


  getMatchingSuggestion(data) {
    return new Promise((resolve) => {
      const allSuggestions = [];
      data.filter((suggestion, index) => {
        const match = this.lookupSuggestions(this.queryValue, suggestion);
        if (match) {
          allSuggestions.push({
            index,
            match,
            value: suggestion,
          });
        }

        return allSuggestions;
      });

      const firstSuggestion = allSuggestions.slice(0, 1);

      predictableMethods.insertSuggestion(
        this.predictableContainer.view,
        allSuggestions,
        this.suggestionText
      );

      return resolve({
        matches: allSuggestions.length,
        list: firstSuggestion,
      });
    });
  }

  /*Method to call suggesstions without an extra keyup*/

  reRenderSuggestion= () =>{
    const getAllSuggestions = () => {
      const text = this.editor.textContent;
      const currentText = (this.queryValue =
        this.context && this.context.getData
          ? this.context.getData(text)
          : text);
      const triggerCondition = currentText
        ? currentText.length > this.sensitivity &&
          currentText.replace(/ /g, "").length
        : "";
      const predictableEventHandler = ( results) => {
        this.editor.dispatchEvent(
          new Polyfill.CustomEventWrapper("Predictable", {
            bubbles: true,
            detail: {
              //event: e,
              input: text,
              context: currentText,
              matches: results ? results.matches : null,
              results: results ? results.list : null,
            },
            cancelable: true,
          })
        );
      };

      const selected = this.onTabPress;
      const resultsList = this.predictableContainer.view;
      const clearResults = predictableMethods.clearResults(resultsList);

      if (triggerCondition) {
        this.getMatchingSuggestion(this.suggestionsData).then((suggestions) => {
          predictableEventHandler(suggestions);

          if (selected) {
            predictableMethods.getSelection(
              this.predictableContainerId,
              this.editor,
              resultsList,
              selected,
              suggestions
            );
          }
        });
      } else {
        predictableEventHandler();
        predictableMethods.clearResults(this.predictableContainer.view);
      }
    };
    getAllSuggestions();
  }

  renderSuggestions = () => {
    this.editor.addEventListener("keyup", (e) => {
      this.suggestionsData = this.data.source;
      getAllSuggestions(e);
    });
    const getAllSuggestions = (e) => {
      const text = this.editor.textContent;
      const currentText = (this.queryValue =
        this.context && this.context.getData
          ? this.context.getData(text)
          : text);
      const triggerCondition = currentText
        ? currentText.length > this.sensitivity &&
          currentText.replace(/ /g, "").length
        : "";
      const predictableEventHandler = (e, results) => {
        this.editor.dispatchEvent(
          new Polyfill.CustomEventWrapper("Predictable", {
            bubbles: true,
            detail: {
              event: e,
              input: text,
              context: currentText,
              matches: results ? results.matches : null,
              results: results ? results.list : null,
            },
            cancelable: true,
          })
        );
      };

      const selected = this.onTabPress;
      const resultsList = this.predictableContainer.view;
      const clearResults = predictableMethods.clearResults(resultsList);

      if (triggerCondition) {
        this.getMatchingSuggestion(this.suggestionsData).then((suggestions) => {
          predictableEventHandler(e, suggestions);

          if (selected) {
            predictableMethods.getSelection(
              this.predictableContainerId,
              this.editor,
              resultsList,
              selected,
              suggestions
            );
          }
        });
      } else {
        predictableEventHandler(e);
        predictableMethods.clearResults(this.predictableContainer.view);
      }
    };
  };
}
